import { useTranslation } from "react-i18next";
import Project from "./Project";

import classes from "./Projects.module.scss";
import BaseContainer from "../../ui/BaseContainer/BaseContainer";
import { AnimationOnScroll } from "react-animation-on-scroll";

type ListType = {
  id: string;
  title: string;
  subtitle: string;
};

const Projects = () => {
  const { t } = useTranslation();

  const list: ListType[] = t("projects.list", { returnObjects: true });

  return (
    <BaseContainer className={classes.projects} id="projects">
      <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce>
        <h3 className={classes["projects-title"]}>{t("projects.title")}</h3>
      </AnimationOnScroll>

      <ul className={classes["projects-list"]}>
        {list.map(({ id, ...project }) => (
          <Project
            key={project.title}
            link={`/projects/${id}`}
            imgSrc={require(`@assets/images/main/projects/${id}.png`)}
            {...project}
          />
        ))}
      </ul>
    </BaseContainer>
  );
};

export default Projects;
